import { PageTypes } from '@sironamedical/common/constants/pageTypes';
import { AppRoutePath } from '../config/constants';
import { matchPath } from 'react-router-dom';
import { matchPaths } from './matchPaths';

export { PageTypes } from '@sironamedical/common/constants/pageTypes';

export const PAGE_TYPES = PageTypes;

/**
 * Returns the pathname of the URL
 * @param {*} str Accepts either an absolute URl a full URL (i.e. location.href) or just a path (i.e. location.pathname or from the PATH constant object)
 * @returns {string} Returns the pathname of the URL. str is returned if it is not a valid URL
 */
export function getPathName(str: string): string {
  try {
    // Assume str is a path if it starts with a forward slash
    return new URL(str.startsWith('/') ? `${window.location.origin}${str}` : str).pathname;
  } catch (err: any) {
    return str;
  }
}

export function getPageType(url: string): PageTypes {
  const pathname = getPathName(url);

  if (matchPath(AppRoutePath.HOME, pathname)) {
    return PAGE_TYPES.HOME;
  } else if (matchPaths(PageTypes.VIEWER, pathname)) {
    return PAGE_TYPES.VIEWER;
  } else if (
    matchPath({ path: AppRoutePath.REPORTER, end: false }, pathname) ||
    matchPath({ path: AppRoutePath.REPORTER_BLANK, end: false }, pathname)
  ) {
    return PAGE_TYPES.REPORTER;
  } else if (matchPath(AppRoutePath.PATIENT_JACKET, pathname)) {
    return PAGE_TYPES.WORKLIST;
  } else if (matchPath(AppRoutePath.WORKLIST_SEARCH, pathname)) {
    return PAGE_TYPES.WORKLIST;
  } else if (matchPath(AppRoutePath.WORKLIST, pathname)) {
    return PAGE_TYPES.WORKLIST;
  } else if (matchPaths(PageTypes.PATIENT_JACKET, pathname)) {
    return PAGE_TYPES.PATIENT_JACKET;
  } else if (matchPaths(PageTypes.AI_SANDBOX, pathname)) {
    return PAGE_TYPES.AI_SANDBOX;
  } else if (matchPath(AppRoutePath.LOGIN, pathname)) {
    return PAGE_TYPES.LOGIN;
  } else if (matchPath({ path: AppRoutePath.ADMIN, end: false }, pathname)) {
    return PAGE_TYPES.ADMIN;
  } else {
    return PAGE_TYPES.UNKNOWN;
  }
}
